const initialState = {
  data: {},
  balanceSellingAccounts: [],
  changePasswordModalActive: false,
  originalAmazonAccounts: [],
  formState: {
    data: {
      amazonAccounts: [],
    },
  },
};

function mapAccount(account, index) {
  return {
    id: Math.random(),
    ...account,
    index,
    deactivated: account.deactivated || false,
    external: account.external || false,
    parseBalance: account.parseBalance || false,
    autoDisabled: account.autoDisabled || false,
    isDeleted: account.isDeleted || false,
    manual: account.manual || false,
  }
}

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_BALANCE_SELLING_ACCOUNTS': {
      const { accounts } = payload;
      return {
        ...state,
        balanceSellingAccounts: accounts,
      };
    }
    case 'SET_DYNAMIC_FORM_DATA': {
      const { amazonAccounts } = payload;
      const mappedAccounts = amazonAccounts.map(mapAccount);
      return {
        ...state,
        originalAmazonAccounts: mappedAccounts,
        formState: {
          data: {
            amazonAccounts: mappedAccounts,
          },
        },
      };
    }
    case 'ADD_DYNAMIC_FORM_DATA_ITEM': {
      const { key, value } = payload;
      return {
        ...state,
        formState: {
          ...state.formState,
          data: {
            ...state.formState.data,
            [key]: [
              ...state.formState.data[key],
              (key === 'amazonAccounts' ? mapAccount(value, state.formState.data[key].length) : value),
            ],
          },
        },
      };
    }
    case 'ADD_DYNAMIC_FORM_DATA_ITEMS': {
      const { key } = payload;
      let { values } = payload;
      if (key === 'amazonAccounts') {
        const length = state.formState.data[key].length;
        values = values.map((value, i) => {
          return mapAccount(value, (length + i));
        })
      }
      return {
        ...state,
        formState: {
          ...state.formState,
          data: {
            ...state.formState.data,
            [key]: [
              ...state.formState.data[key],
              ...values,
            ],
          },
        },
      };
    }
    case 'REMOVE_DYNAMIC_FORM_DATA_ITEM': {
      const { key, id, restore } = payload;
      const index = state.formState.data[key].findIndex(item => item.id === id);
      return {
        ...state,
        formState: {
          ...state.formState,
          data: {
            ...state.formState.data,
            [key]: [
              ...state.formState.data[key].slice(0, index),
              {
                ...state.formState.data[key][index],
                isDeleted: !restore,
              },
              ...state.formState.data[key].slice(index + 1),
            ],
          },
        },
      };
    }
    case 'HARD_REMOVE_DYNAMIC_FORM_DATA_ITEM': {
      const { key, id } = payload;
      const index = state.formState.data[key].findIndex(item => item.id === id);
      if (index === -1) {
        throw new Error('Failed to find index of record');
      }
      const resultState = {
        ...state,
        formState: {
          ...state.formState,
          data: {
            ...state.formState.data,
            [key]: [
              ...state.formState.data[key].slice(0, index),
              ...state.formState.data[key].slice(index + 1),
            ].map((item, i) => ({
              ...item,
              // we need to re-index the items after removing one
              index: i,
            })),
          },
        },
      };
      console.log(resultState);
      return resultState;
    }
    case 'ON_DYNAMIC_FORM_DATA_FORM_UPDATE': {
      const { formState } = payload;
      return {
        ...state,
        formState: formState,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Data/Data.reducer.js